<template>
  <div>
    <div class="smeta-tabs tw-mb-4">
      <button
        class="smeta-tab"
        :class="{ 'smeta-tab--active': activeSubTab === 'history' }"
        @click="activeSubTab = 'history'"
      >
        Смета по договору
      </button>
      <button
        class="smeta-tab"
        :class="{ 'smeta-tab--active': activeSubTab === 'actual' }"
        @click="activeSubTab = 'actual'"
      >
        Актуальная смета
      </button>
    </div>

    <ProjectSmetaHistoryReport
      v-if="activeSubTab === 'history'"
      :project-id="computedProjectId"
      :project-entrance-id="computedEntranceId"
    />

    <ProjectSmetaActual
      v-if="activeSubTab === 'actual'"
      :params="params"
      :active-data="activeData"
    />
  </div>
</template>

<script>
import ProjectSmetaHistoryReport from '@/views/ProjectsEntry/ProjectSmetaHistoryReport.vue'
import ProjectSmetaActual from '@/views/ResidentialSettings/ProjectSmetaActual.vue'

export default {
  name: 'ProjectSmetaTabs',
  components: {
    ProjectSmetaHistoryReport,
    ProjectSmetaActual,
  },
  props: {
    projectId: {
      type: [Number, String],
      default: null,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    activeData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      activeSubTab: 'history',
    }
  },
  computed: {
    computedProjectId() {
      const id = this.params?.project_id ?? this.projectId
      return id ? Number(id) : null
    },
    computedEntranceId() {
      const id = this.params?.project_entrance_id
      return id ? Number(id) : null
    },
  },
}
</script>

<style scoped lang="scss">
.smeta-tabs {
  display: flex;
  border-bottom: 2px solid #e5e7eb;
  gap: 0;
}

.smeta-tab {
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    color: #374151;
    border-bottom-color: #d1d5db;
  }
}

.smeta-tab--active {
  color: #2f80ed;
  border-bottom-color: #2f80ed;
  font-weight: 600;
}
</style>
